import { call, put } from 'redux-saga/effects';
import {
  fetchProfilePictureRequest,
  uploadProfilePictureFailure,
  uploadProfilePictureSuccess,
} from '../actions';
import { uploadProfilePicture } from '../api';
import { UploadProfilePictureRequestAction } from '../types';
import { ApiError, ApiResponse } from 'store/api/types';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { turnMessageOn } from 'store/app/actions';
import { checkResponse } from 'store/utils';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* uploadProfilePictureSaga(
  action: UploadProfilePictureRequestAction
) {
  try {
    let err: ApiError | null;

    const { base64, userId } = action.payload;
    const response: ApiResponse = yield call(uploadProfilePicture, base64);

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    yield put(uploadProfilePictureSuccess());
    yield put(fetchProfilePictureRequest(userId));
    
    const message: MessageData = {
      title: i18n.t('notifications.profile-picture-saved'),
      description: i18n.t('notifications.your-profile-picture-has-been-updated-successfully'),
      type: MessageStates.SUCCESS,
    };
    yield put(turnMessageOn(message));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(uploadProfilePictureFailure());
  }
}
